import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { selectAllCompanies } from "../../../../../../../redux/mgmtCo/managementSlice";

const TableCell = React.memo(
  ({ field, customer, handleIdClick, width, dropdownLists }) => {
    const managementCompanies = useSelector(selectAllCompanies);

    let displayValue = customer[field.key];

    if (field.key === "managementID") {
      // Use the correct property name from the management company object
      const company = managementCompanies.find(
        (comp) => comp.managementId === customer.managementID
      );
      displayValue = company ? company.companyName : "-";
    }

    // Map paymentID
    if (field.key === "paymentID") {
      const term =
        Array.isArray(dropdownLists?.allPaymentTerms) &&
        dropdownLists.allPaymentTerms.find(
          (term) => term.id === customer.paymentID
        );
      displayValue = term ? term.name : "-";
    }

    // Map taxDetailID
    if (field.key === "taxDetailID") {
      const detail =
        Array.isArray(dropdownLists?.allTaxDetails) &&
        dropdownLists.allTaxDetails.find(
          (detail) => detail.id === Number(customer.taxDetailID)
        );
      displayValue = detail ? detail.description : "-";
    }

    // Map salesID
    if (field.key === "salesID") {
      const person =
        Array.isArray(dropdownLists?.allSalesPersons) &&
        dropdownLists.allSalesPersons.find(
          (person) => person.id === customer.salesID
        );
      displayValue = person ? `${person.firstName} ${person.lastName}` : "-";
    }

    // Use a fallback if displayValue is null or undefined.
    const finalDisplay = String(displayValue) ?? "-";

    const contentStyle = {
      display: "inline-block",
      width: width,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };

    const content = <span style={contentStyle}>{finalDisplay}</span>;

    if (field.key === "customerName") {
      return (
        <td
          className="px-4 py-1 cursor-pointer text-sss-info"
          onClick={(e) => {
            e.stopPropagation();
            if (handleIdClick) {
              handleIdClick(customer);
            }
          }}
        >
          <Tooltip
            title={`Open Customer ${customer[field.key]}`}
            enterDelay={1000}
          >
            {content}
          </Tooltip>
        </td>
      );
    }

    return (
      <td className="px-4 py-1">
        <Tooltip title={finalDisplay}>{content}</Tooltip>
      </td>
    );
  }
);

TableCell.propTypes = {
  field: PropTypes.object.isRequired,
  customer: PropTypes.object.isRequired,
  handleIdClick: PropTypes.func,
  width: PropTypes.number.isRequired,
};

export default TableCell;
